import { BrowserRouter, Route, Routes } from "react-router-dom";
import Footer from "@/components/Footer";
import Header from "@/components/Header";
import ScrollToTop from "@/components/ScrollToTop";
import Accessibility from "@/pages/Accessibility";
import DrAmy from "@/pages/DrAmy";
import DrBilous from "@/pages/DrBilous";
import HipaaPolicy from "@/pages/HipaaPolicy";
import Home from "@/pages/Home";
import LocationPage from "@/pages/LocationPage";
import NotFound from "@/pages/NotFound";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import ServicePage from "@/pages/ServicePage";

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-cream-50">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/dr-amy" element={<DrAmy />} />
            <Route path="/dr-bilous" element={<DrBilous />} />
            <Route path="/services/:slug" element={<ServicePage />} />
            <Route path="/locations/:slug" element={<LocationPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/hipaa-policy" element={<HipaaPolicy />} />
            <Route path="/accessibility" element={<Accessibility />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}
